<template lang="pug">
.wrapper-file-management-approval
  h2 gerenciamento de arquivos

  .grid
    .visualizacao-de-arquivo
      template(v-if="!carregandoInfos")
        template(v-if="ehPdf")
          object(
            :data="infoDeAprovacao.arquivo"
            type="application/pdf"
            width="100%"
            height="100%"
          )
            iframe(
              :src="infoDeAprovacao.arquivo"
              width="100%"
              height="100%"
              style="border: none;"
            )
              .fallback
                span Ocorreu um erro ao tentar visualizar esse arquivo.
                a(:href="infoDeAprovacao.arquivo" download target="_blank") Clique aqui para fazer download.

        template(v-else)
          viewer(:images="[infoDeAprovacao.arquivo]" :options="configVisualizadorDeImagens")
            img(:src="infoDeAprovacao.arquivo")
      template(v-else)
        SkeletonBox(key="visualizacaoDeArquivo" width="100%" height="100%")
    .informacoes-e-assinatura
      template(v-if="!carregandoInfos")
        .titulo
          span {{ this.infoDeAprovacao.descricao }}
        .aviso
          span Faça a leitura do documento com atenção antes de aceitar o pedido
        .quem-visualizou
          //- .visualizado-por visualizado por:
          //- .info-de-visualizacao(v-for="pedido in visualizacoes")
          //-   .nome-e-email {{ formataUsuarioComEmail(pedido.usuarioVinculado) }}
          //-   //- .cpf -
          //-   .horario-e-data {{ datetimeParaString(pedido.dataDeAlteracaoDaSituacao) }}
        .texto-de-aceite
          .voce-aceita Você aceita
          .mensagem-de-aprovacao {{ infoDeAprovacao.mensagemDeAprovacao }}
        .justificativa
          PTextField(
            v-model="justificativa"
            label="forneça uma justificativa para a sua resposta (obrigatória em caso de reprovação)"
            ref="inputDeJustificativa"
          )
        .flag-de-aceite
          PCheckbox(
            :label="`afirmo ter lido e avaliado o arquivo em ${dataDeHoje} e entendo que minha resposta a este documento tem validade legal`"
            v-model="flagDeAceite"
            ref="flagDeAceite"
          )
        .botoes
          span.pseudolink(@click="voltarParaListagem") voltar para a tabela
          PButton(color="success" size="md" @click="aprovar" :loading="carregandoAprovacao" :disabled="carregandoRejeicao" block) aceitar
          PButton(color="danger" size="md" @click="rejeitar" :loading="carregandoRejeicao" :disabled="carregandoAprovacao" block) rejeitar
      template(v-else)
        .titulo
          SkeletonBox(key="titulo" width="100%" height="25px")
        .aviso
          SkeletonBox(key="aviso" width="100%" height="16px")
        .quem-visualizou
          .info-de-visualizacao
            SkeletonBox(key="quemVisualizou" width="50%" height="84px")
        .texto-de-aceite
          SkeletonBox(key="textoDeAceite" width="100%" height="44px")
        .justificativa
          SkeletonBox(key="justificativa" width="100%" height="59px")
        .flag-de-aceite
          SkeletonBox(key="flagDeAceite" width="100%" height="47px")
        .botoes
          SkeletonBox(key="botaoVoltar" width="0" height="32px")
          SkeletonBox(key="botaoAceitar" width="100%" height="32px")
          SkeletonBox(key="botaoRejeitar" width="100%" height="32px")
</template>

<script>
import moment from 'moment'

export default {
  name: 'FileManagementApproval',
  props: {
    id: {type: String, required: true}
  },
  async created () {
    this.carregandoInfos = true

    try {
      const fields = [
        'id', 'descricao', 'usuario_vinculado', 'motivo',
        'data_limite_pedido_utc', 'situacao',
        'situacao_pedidos_individuais', 'data_de_criacao_pedido_utc'
      ]
      const infoCompleta = await this.$API.gerenciamentoDeArquivos.get({
        id: this.id,
        fields: JSON.stringify(fields)
      })
      if (infoCompleta.status === 200) {
        this.infoDeAprovacao = infoCompleta.data.success[0]

        // Checagem meio boba, talvez exista uma maneira melhor...
        const { arquivo } = this.infoDeAprovacao
        if (arquivo.includes('.pdf')) this.ehPdf = true
      }

      const resultado = await this.$API.consultaIp.get()
      if (resultado.status === 200) {
        this.enderecoIp = resultado.body.ipDoUsuario
      } else {
        console.log('não foi possível pegar ip')
      }
    } catch (e) {
      console.error(e)
      this.$modalDeErro(e?.data?.error ? e.data.error : 'Ocorreu um erro! Tente novamente. Se o erro persistir entre em contato com o suporte.')
      this.voltarParaListagem()
    } finally {
      this.carregandoInfos = false

      if (navigator.geolocation) {
        const pos = await this.pegaCoordenadas()
        this.posicao = {
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude
        }
      } else {
        this.posicao = null
        console.log('não foi possível pegar geolocalização')
      }
    }
  },
  data () {
    return {
      infoDeAprovacao: undefined,
      carregandoInfos: false,
      carregandoAprovacao: false,
      carregandoRejeicao: false,
      ehPdf: false,
      justificativa: '',
      flagDeAceite: false,
      dataDeHoje: moment().format('DD.MM.YYYY'),
      posicao: null,
      enderecoIp: null,
      configVisualizadorDeImagens: {
        inline: true,
        navbar: false,
        toolbar: false,
        movable: true,
        transition: false,
        keyboard: false,
        rotatable: false
      }
    }
  },
  computed: {
    visualizacoes () {
      return this.infoDeAprovacao.situacaoPedidosIndividuais.filter(pedido => {
        return pedido.situacao === 'aprovado' || pedido.situacao === 'rejeitado'
      })
    }
  },
  methods: {
    async aprovar () {
      if (!this.flagDeAceite) {
        this.$modalDeInformacao('Aceite as condições antes de prosseguir com a confirmação do documento.')
        return
      }

      this.carregandoAprovacao = true

      try {
        await this.$API.aprovacaoIndividualDeArquivo.update(
          {id: this.infoDeAprovacao.id, acoes: 'aprovar'},
          {
            mensagem_de_justificativa: this.justificativa,
            localizacao: this.posicao,
            endereco_ip: this.enderecoIp
          }
        )

        this.$modalDeSucesso('Ação realizada com sucesso!')
        this.voltarParaListagem()
      } catch (e) {
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível aceitar o arquivo!')
      } finally {
        this.carregandoAprovacao = false
      }
    },
    async rejeitar () {
      if (this.justificativa === '') {
        await this.$swal({type: 'info', text: 'Por favor, justifique o porque está rejeitando este documento.'})
        this.$refs.inputDeJustificativa.focus()
        return
      }
      if (!this.flagDeAceite) {
        this.$modalDeInformacao('Aceite as condições antes de prosseguir com a confirmação do documento.')
        return
      }

      this.carregandoRejeicao = true

      try {
        await this.$API.aprovacaoIndividualDeArquivo.update(
          {id: this.infoDeAprovacao.id, acoes: 'rejeitar'},
          {
            mensagem_de_justificativa: this.justificativa,
            localizacao: this.posicao,
            endereco_ip: this.enderecoIp
          }
        )

        this.$modalDeSucesso('Ação realizada com sucesso!')
        this.voltarParaListagem()
      } catch (e) {
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível rejeitar o arquivo!')
      } finally {
        this.carregandoRejeicao = false
      }
    },
    voltarParaListagem () {
      this.$router.push('/gerenciamento-de-arquivos/list')
    },
    formataUsuarioComEmail (usuario) {
      if (!usuario) return '-'

      const { name, email } = usuario

      return `${name} (${email})`
    },
    datetimeParaString (datetime) {
      if (!datetime) return '-'
      const data = moment(datetime, 'YYYY-MM-DDTHH:mm:ss')
      return data.format('HH:mm | DD.MM.YYYY')
    },
    pegaCoordenadas () {
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper-file-management-approval {
  h2 { text-align: center; }

  .grid {
    height: 80vh;
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    grid-template-areas:
      'visualizacao-de-arquivo informacoes-e-assinatura';
  }

  .visualizacao-de-arquivo {
    grid-area: visualizacao-de-arquivo;

    img {
      max-height: 80vh;
      max-width: 100%;
    }
  }

  .informacoes-e-assinatura {
    padding: 22px 10px;
    grid-area: informacoes-e-assinatura;
    display: grid;
    overflow-y: auto;
    grid-template-rows: min-content min-content 1fr min-content min-content min-content;

    .titulo {
      margin-bottom: 20px;

      span {
        font-size: 25px;
        font-weight: 500;
        color: var(--color-info);
        text-align: center;
      }
    }
    .aviso {
      margin-bottom: 20px;
    }
    .quem-visualizou {
      font-size: 16px;
      overflow-y: auto;

      .visualizado-por { font-size: 13px; margin-bottom: 5px; }
      .info-de-visualizacao { margin-bottom: 15px; }
    }
    .texto-de-aceite {
      margin-top: 20px;
      font-size: 16px;

      .mensagem-de-aprovacao {
        color: var(--color-info);
      }
    }
    .justificativa {
      margin-top: 20px;
    }
    .flag-de-aceite {
      padding: 10px 0;
    }
    .botoes {
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: auto minmax(0, 152px) minmax(0, 152px);
      justify-items: end;
      align-items: center;
      column-gap: 1px;

      .pseudolink {
        font-size: 16px;
        color: var(--color-info);
        cursor: pointer;
        margin-right: 20px;
      }
    }
  }
}
</style>

<style lang="scss">
.viewer-backdrop {
  background-color: rgba(249, 249, 249, 1);
}
.viewer-title {
  color: black;
}
</style>
